import { useAppStore } from '@/store/useAppStore.ts'
import { FormulaDisplay } from '@/components/shared/FormulaDisplay.tsx'

export function FormulaExplanationPanel() {
  const result = useAppStore((s) => s.runtimeResult)
  const show = useAppStore((s) => s.showFormulaExplanation)
  const toggle = useAppStore((s) => s.toggleFormulaExplanation)

  if (!result?.formulaExplanation) return null

  return (
    <div className="formula-explanation-panel">
      <button
        type="button"
        className="formula-explanation-panel__toggle"
        onClick={toggle}
        aria-expanded={show}
      >
        {show ? 'Hide' : 'Show'} Formula
      </button>
      <FormulaDisplay formula={result.formulaExplanation} visible={show} />
    </div>
  )
}
